import constants from "@/data/constants.js";
import channelSpecialtyDoseformData from "@/data/channelSpecialtyDoseformData.js";

export default function useTotalCombiData() {
  function totalCombiData(content, response, list) {
    // 전체 합치기 만들기
    let arrElements = [];
    let dataElement = {};
    let data = {};
    response[0].forEach((el, index) => {
      dataElement = {
        code: content.subContents[0].code,
        id: el.id,
      };
      arrElements = [...arrElements, dataElement];
    });
    data = {
      // code: list.code,id: list.code 합치기 일때 없음
      type: 1,
      name: list.name,
      englishName: list.englishName,
      elements: arrElements,
    };
    // console.log("data ::", data);
    return data;
  }
  
  function patternContentTotalList(code, res) {
    if (code === constants.CONSTANT_CHANNEL_CODE) {
      channelSpecialtyDoseformData.channel.forEach((channel) => {
        res[0] = [channel, ...res[0]];
      });
    }

    if (code === constants.CONSTANT_CHANNEL_SOB_CODE) {
      channelSpecialtyDoseformData.channel_sob.forEach((channel) => {
        res[0] = [channel, ...res[0]];
      });
    }

    if (code === constants.CONSTANT_DOSEFORM_CODE) {
      channelSpecialtyDoseformData.doseform.forEach((doseform) => {
        res[0] = [doseform, ...res[0]];
      });
    }

    if (code === constants.CONSTANT_CL_SPECIALTY_CODE) {
      channelSpecialtyDoseformData.specialty.forEach((specialty) => {
        res[0] = [specialty, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_AGE_CODE) {
      channelSpecialtyDoseformData.age.forEach((age) => {
        res[0] = [age, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_GENDER_CODE) {
      channelSpecialtyDoseformData.gender.forEach((gender) => {
        res[0] = [gender, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_PATIENTTYPE_CODE) {
      channelSpecialtyDoseformData.patienttype.forEach((patienttype) => {
        res[0] = [patienttype, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_VISITTYPE_CODE) {
      channelSpecialtyDoseformData.visittype.forEach((visittype) => {
        res[0] = [visittype, ...res[0]];
      });
    }

    if (code === constants.CONSTANT_CL_PRODUCTTYPE_CODE) {
      channelSpecialtyDoseformData.producttype.forEach((producttype) => {
        res[0] = [producttype, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_DIAGNOSISTYPE_CODE) {
      channelSpecialtyDoseformData.diagnosistype.forEach((diagnosistype) => {
        res[0] = [diagnosistype, ...res[0]];
      });
    }
    if (code === constants.CONSTANT_CL_TESTTYPE_CODE) {
      channelSpecialtyDoseformData.testtype.forEach((testtype) => {
        res[0] = [testtype, ...res[0]];
      });
    }

    // console.log("res ::", res);
    return res;
  }

  return { totalCombiData, patternContentTotalList };
}